// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../~/@master/webinfra-frontend-components/src/components/Button/Button.less
// module id = 1025
// module chunks = 0